module.exports = __webpack_public_path__ + "img/public/siteImages/whiteFooterWave.svg?0a21b829";